<template>
  <div class="signature-container">
    <div class="signature-card">
      <div class="signature-wrapper">
        <canvas
          ref="signatureCanvas"
          id="signature-pad"
          class="signature-pad"
          width="500"
          height="200"
        ></canvas>
        <div v-if="isEmpty" class="signature-placeholder">
          <svg class="signature-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <p class="placeholder-text">Semnează aici</p>
        </div>
      </div>
      <div class="signature-actions">
        <button-form
          button-name="Resetează semnătura"
          button-class="clear"
          :on-click="clearSignature"
        ></button-form>
      </div>
    </div>
    <span v-if="!isValid" class="error-message">{{ errorText }}</span>
  </div>
</template>

<script>
import SignaturePad from "signature_pad";
import ButtonForm from "./ButtonForm";

let signaturePad = null;

export default {
  components: {
    ButtonForm
  },
  props: {
    signatureLabel: String,
    errorText: String,
    isValid: Boolean,
    saveSignature: Function,
    signatureDescription: String
  },
  data() {
    return {
      isEmpty: true
    };
  },
  mounted() {
    this.$nextTick(function () {
      console.log(this.$refs.signatureCanvas);
      signaturePad = new SignaturePad(
        this.$refs.signatureCanvas,
        {
          backgroundColor: "rgba(255, 255, 255, 0)",
          penColor: "rgb(0, 0, 0)"
        }
      );
      
      // Track if signature is empty
      signaturePad.addEventListener("beginStroke", () => {
        this.isEmpty = false;
      });
      
      signaturePad.addEventListener("endStroke", () => {
        this.isEmpty = signaturePad.isEmpty();
      });
      
      this.saveSignature(signaturePad);
    });
  },
  methods: {
    clearSignature: function (event) {
      signaturePad.clear();
      this.isEmpty = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.signature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 16px;
}

.signature-card {
  width: 100%;
  max-width: 500px;
  background-color: #fafafa;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
    border-color: #d1d5db;
  }
}

.signature-wrapper {
  position: relative;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #fff;
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  overflow: hidden;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #cbd5e1;
  }

  .signature-pad {
    width: 100%;
    height: 200px;
    display: block;
    cursor: crosshair;
  }
  
  .signature-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    color: #94a3b8;
    
    .signature-icon {
      margin-bottom: 12px;
      opacity: 0.5;
    }
    
    .placeholder-text {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #94a3b8;
    }
  }
}

.signature-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.clear {
  background-color: #fff;
  color: #4a5568;
  border: 1px solid #d1d5db;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  width: auto;
  min-width: 155px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f9fafb;
    border-color: #9ca3af;
    color: #1a1a1a;
  }
  
  &:active {
    background-color: #f3f4f6;
  }
}

.error-message {
  display: block;
  margin: 12px 0 0 0;
  color: #bd1f23;
  font-size: 14px;
  text-align: center;
  width: 100%;
  max-width: 500px;
}

@media (max-width: 768px) {
  .signature-card {
    padding: 20px;
    max-width: 100%;
  }
  
  .signature-wrapper .signature-pad {
    height: 180px;
  }
}
</style>
